import React from 'react';

import MP_profile from 'assets/team_photos/mp_profile.jpg';
import EGGRO_profile from 'assets/team_photos/eggro_profile.jpg';
import CD_profile from 'assets/team_photos/cd_profile.jpg';
import JB_profile from 'assets/team_photos/jb_profile.jpg';
import default_profile from 'assets/referrals_icon.svg';
import './styles.scss';

const tgPrefix = 'https://t.me/';

type Member = {
  name: string,
  handle?: string,
  bio: React.JSX.Element,
  former: boolean,
  image?: string,
}

const teamMembers: Member[] = [
  {
    name: 'Michael Pines',
    handle: 'michael_pines',
    bio: (<p>Founder, maintainer. Built most of the website & smart contract infrastructure; most commonly seen fighting-off spam-bots in the @dogebets Telegram community</p>),
    image: MP_profile,
    former: false,
  },
  {
    name: 'Eggro',
    handle: 'EGGRO93',
    bio: (<p>Community manager, long-term friend of the project. Brings fresh ideas, crazy schemes, ensures our community is updated; takes care of our visibility in the DeFi prediction game & play-to-earn jungle</p>),
    image: EGGRO_profile,
    former: false,
  },
  {
    name: 'Corey',
    //handle = 'coreydeez';
    bio: (<p>Founder, retired</p>),
    //image: CD_profile,
    former: true,
  },
  {
    name: 'JB',
    //handle = 'JB_DogeBets';
    bio: (<p>Founder, retired</p>),
    //image: JB_profile,
    former: true,
  },
];

const currentMembers = teamMembers.filter((member) => !member.former);
const formerMembers = teamMembers.filter((member) => member.former);

function MemberCard({ member }: { member: Member }) {
  let pfp = (<img src={default_profile} alt={`${member.name} PFP`} />);
  let name = (<p>{member.name}</p>);
  if (member.image)
    pfp = (<img src={member.image} alt={`${member.name} PFP`} />);
  if (member.handle)
    name = (<a href={tgPrefix + member.handle} target='_blank' rel='noopener noreferrer'>{member.name}</a>);

  return (
    <div className='Member'>
      <div className='Headline'>
        {pfp}
        {name}
      </div>
      {member.bio}
    </div>
  );
}


function AboutUs(props: any) {
  return (<div className='AboutUs'>
    <p>DogeBets is a predictions gaming platform.</p>

    <div className='TeamMembers'>
      {currentMembers.map((member) => (
        <MemberCard key={member.name} member={member} />
      ))}
    </div>

    <div className='TeamMembers'>
      {formerMembers.map((member) => (
        <MemberCard key={member.name} member={member} />
      ))}
    </div>

    <p>We are also supported by a few mods & friends of the project across our communities.</p>
    <p>
      Our platform here at DogeBets.gg is the only official website.{' '}
      Currently <b>we do not have a token</b>
    </p>
  </div>);
}

export default AboutUs;